import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import AnimationRevealPage from "../../../components/helpers/AnimationRevealPage";
import MainCabinetHeader from "../../../components/headers/MainCabinetHeader";
import Step1 from "./Step/step1";
import Step2 from "./Step/STEP2";
import Step3Backend from "./Step/STEP3";
import Step4and5Step from "./Step/Step4and5";
import Button from "./Step/Buttons";
import Footer from "../../../components/footers/MainFooterWithLinks";
import { Toaster } from "react-hot-toast";
const PageContainer = styled.div`
    ${tw`min-h-screen flex flex-col`};
`;

const ExpectedLink = () => {
    const [paymentData, setPaymentData] = useState({
        totalCostUSD: 0,
        totalCostKZT: 0,
        insuranceAmount: 0,
        customDutyKZT: 0,
        deliveryCost: 0,
        step3DeliveryCost: 0,
        deliveryPointCode: null, // Код ПВЗ CDEK
        deliveryPointAddress: null, // Адрес ПВЗ
        tariffCode: 136, // Код тарифа CDEK (по умолчанию склад-склад)
    });
    const [insuranceIncluded, setInsuranceIncluded] = useState(true); // Страхование обязательно согласно Rates

    const [parcelData, setParcelData] = useState({});
    const [servicesIds, setServicesIds] = useState([]);
    const [parcelId, setParcelId] = useState(null);

    const handleDataPassFromStep1 = ({ parcelId, servicesIds, parcelData, city, recipient }) => {


        setParcelId(parcelId);
        setServicesIds(servicesIds);
        setParcelData(parcelData);
        setPaymentData((prevState) => ({
            ...prevState,
            city,
            recipient, // Сохраняем данные о получателе
        }));
    };


    const handleDataPass = (data) => {
        if (!data || typeof data !== "object") {
            return;
        }

        setPaymentData((prevState) => {
            const updatedData = { ...prevState, ...data };
            return updatedData;
        });
    };



    const handleInsuranceUpdate = (data) => {
        if (!data || typeof data !== "object") {

            return;
        }

        setPaymentData((prevState) => ({
            ...prevState,
            totalCostKZT: data.totalCostKZT || prevState.totalCostKZT,
            insuranceAmount: data.insuranceAmount || prevState.insuranceAmount,
            customDutyKZT: data.customDutyKZT || prevState.customDutyKZT,
        }));

        if (data.insuranceIncluded !== undefined) {
            setInsuranceIncluded(data.insuranceIncluded);
        }
    };

    const handleStep3DeliveryCostUpdate = (deliveryData) => {
        console.log('📦 Updating delivery data:', deliveryData);

        // Если передан объект с данными о доставке
        if (typeof deliveryData === 'object') {
            setPaymentData((prevState) => ({
                ...prevState,
                step3DeliveryCost: deliveryData.deliveryCost || 0,
                deliveryPointCode: deliveryData.deliveryPointCode || null,
                deliveryPointAddress: deliveryData.deliveryPointAddress || null,
                tariffCode: deliveryData.tariffCode || 136,
            }));
        }
        // Если передано просто число (для обратной совместимости)
        else if (typeof deliveryData === 'number') {
            setPaymentData((prevState) => ({
                ...prevState,
                step3DeliveryCost: deliveryData,
            }));
        }
    };



    return (
        <AnimationRevealPage>
            <MainCabinetHeader />
            <PageContainer>
                <Step1
                    onDataPass={(data) => {
                        handleDataPassFromStep1(data);
                    }}
                />
                <Step2
                    onDataPass={(data) => {
                        handleDataPass(data); // Обновление всех данных
                        handleDataPassFromStep1(data); // Обновление данных о получателе
                    }}
                    city={paymentData.city} // Передача города
                />

                <Step3Backend onDeliveryCostUpdate={handleStep3DeliveryCostUpdate} />


                <Step4and5Step
                    onInsuranceUpdate={handleInsuranceUpdate}
                    setInsuranceIncluded={setInsuranceIncluded}
                    insuranceIncluded={insuranceIncluded}
                />
                <Button
                    totalCostUSD={paymentData.totalCostUSD}
                    totalCostKZT={paymentData.totalCostKZT}
                    insuranceAmount={paymentData.insuranceAmount} // Передаём сумму страхования
                    customDutyKZT={paymentData.customDutyKZT} // Передаём таможенную пошлину
                    insuranceIncluded={insuranceIncluded}
                    deliveryCost={paymentData.deliveryCost}
                    parcelId={parcelId}
                    servicesIds={servicesIds}
                    deliveryCosts={paymentData.step3DeliveryCost}
                    deliveryPointCode={paymentData.deliveryPointCode} // Код ПВЗ CDEK
                    deliveryPointAddress={paymentData.deliveryPointAddress} // Адрес ПВЗ
                    tariffCode={paymentData.tariffCode} // Код тарифа CDEK
                />

                <Footer />
            </PageContainer>

            <Toaster position="top-right" reverseOrder={false} />
        </AnimationRevealPage>
    );
};

export default ExpectedLink;